/*
  Lavish quiz, 2026-10-18. Three questions, one result. The third question only appears for
  natural lashes (extension wearers do not curl or wear mascara on their extensions).
  20 Oct: question 1 is "how are your lashes right now?": short or sparse, fine but wanting more
  (both natural lashes), or extensions, lifts or tints (value "yes", the salon path). The answer
  also tags the signup (quiz-lashes-sparse, -more, -salon) for Klaviyo.
  Results:
    extensions + lashes  -> serum-ext      no extensions + lashes + mascara -> duo
    extensions + brows   -> brow           no extensions + lashes + curl    -> lift
    any        + both    -> both           no extensions + lashes + none    -> serum
                                           no extensions + brows            -> brow
*/
class LavishQuiz extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-quiz-form]');
    this.results = this.querySelector('[data-quiz-results]');
    this.tags = this.querySelector('[data-quiz-tags]');
    this.form.addEventListener('change', () => this.update());
    this.querySelector('[data-quiz-again]')?.addEventListener('click', () => this.reset());
    if (new URLSearchParams(location.search).has('customer_posted')) {
      this.results.hidden = false;
      this.querySelector('[data-quiz-email]')?.scrollIntoView({ block: 'center' });
    }
  }

  value(name) {
    const checked = this.form.querySelector(`input[name="${name}"]:checked`);
    return checked ? checked.value : null;
  }

  step(n, show) {
    const fieldset = this.form.querySelector(`[data-step="${n}"]`);
    if (fieldset) fieldset.hidden = !show;
    if (!show) fieldset?.querySelectorAll('input').forEach((input) => (input.checked = false));
  }

  update() {
    const ext = this.value('ext');
    const area = this.value('area');
    this.step(2, Boolean(ext));
    const needsDay = Boolean(ext) && ext !== 'yes' && area === 'lashes';
    this.step(3, needsDay);
    const day = this.value('day');

    let key = null;
    if (ext && area === 'both') key = 'both';
    else if (ext && area === 'brows') key = 'brow';
    else if (ext === 'yes' && area === 'lashes') key = 'serum-ext';
    else if (needsDay && day) key = { mascara: 'duo', curl: 'lift', none: 'serum' }[day];

    this.show(key);
    if (!key) {
      const next = this.form.querySelector('fieldset:not([hidden]) input:not(:checked)');
      if (next && document.activeElement && this.form.contains(document.activeElement)) {
        next.closest('fieldset')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  show(key) {
    this.results.hidden = !key;
    this.results.querySelectorAll('[data-result]').forEach((result) => {
      result.hidden = result.dataset.result !== key;
    });
    if (!key) return;
    if (this.tags) this.tags.value = `newsletter, quiz, quiz-${key}, quiz-lashes-${this.value('ext') === 'yes' ? 'salon' : this.value('ext')}`;
    this.results.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    try {
      window.Shopify?.analytics?.publish?.('lavish_quiz_result', { result: key });
    } catch (error) {
      /* analytics is optional */
    }
  }

  reset() {
    this.form.reset();
    this.step(2, false);
    this.step(3, false);
    this.show(null);
    this.form.querySelector('input')?.focus();
  }
}

if (!customElements.get('lavish-quiz')) customElements.define('lavish-quiz', LavishQuiz);
